import { GET_BASIC_CART, ADD_TO_CART, REMOVE_FROM_CART, CLEAR_CART,DELETE_SERVICE_FROM_CART, ADD_TO_CART_FROM_RECOMMENDED } from '../actions/Types';

const BasicCartReducer = (state={}, action) => {
    switch(action.type){
        case GET_BASIC_CART:
        case ADD_TO_CART:
        case REMOVE_FROM_CART:
        case DELETE_SERVICE_FROM_CART:
            return action.payload
        case CLEAR_CART:
            return {}
        case ADD_TO_CART_FROM_RECOMMENDED:
            return {...state, ...action.payload.added}
        default:
            return state
    }
}

export default BasicCartReducer